// The internal web — pages that only exist inside this Internet Explorer. Not proxied, not on the
// real internet, not on the Wayback Machine. A webring, an Under Construction page, and the door.
// Community ask 2026-09-08: "you could build your own internal web… rings, Under Construction pages…
// enter a password on a website in IE → unlock a secret application".
import React, { useState } from 'react';
import styled from 'styled-components';

import { checkKey, isUnlocked, unlock } from '../Basement/state';

const PAGES = {
  'basement.internetcoin.vip': 'basement',
  'internetcoin.vip/basement': 'basement',
  'www.internetcoin.vip/basement': 'basement',
  'underconstruction.internetcoin.vip': 'construction',
  'internetcoin.vip/underconstruction': 'construction',
  'webring.internetcoin.vip': 'webring',
  'internetcoin.vip/webring': 'webring',
  'ring.internetcoin.vip': 'webring',
};
export const INTERNAL_HOSTS = { basement: 'basement.internetcoin.vip', construction: 'underconstruction.internetcoin.vip', webring: 'webring.internetcoin.vip' };

// "http://basement.internetcoin.vip/" → 'basement' | null
export function resolveInternal(normalized) {
  const s = String(normalized || '').toLowerCase().replace(/\/+$/, '');
  return PAGES[s] || null;
}

function Ring({ goto }) {
  return (
    <div className="iw__ring">
      <span>the internet webring:</span>
      <a onClick={() => goto('webring.internetcoin.vip')}>[ ring ]</a>
      <a onClick={() => goto('underconstruction.internetcoin.vip')}>[ under construction ]</a>
      <a onClick={() => goto('basement.internetcoin.vip')}>[ the basement ]</a>
      <a onClick={() => goto('internetcoin.vip')}>[ home ]</a>
    </div>
  );
}

function Door({ goto }) {
  const [key, setKey] = useState('');
  const [tries, setTries] = useState(0);
  const [state, setState] = useState(isUnlocked() ? 'open' : 'closed'); // closed | denied | open
  function submit(e) {
    e.preventDefault();
    if (checkKey(key)) {
      if (!isUnlocked()) unlock();
      setState('open');
    } else {
      setTries(t => t + 1);
      setState('denied');
      setKey('');
    }
  }
  return (
    <Page>
      <div className="iw__uc"><span>🚧 UNDER CONSTRUCTION 🚧</span></div>
      <div className="iw__marquee"><span>★ members only ★ the basement ★ if you are reading this you were not supposed to find it ★ turn back ★ or don&apos;t ★</span></div>
      <h1>THE BASEMENT</h1>
      <p className="iw__sub">a door on the internal web. below the desktop. below the internet.</p>
      {state === 'open' ? (
        <div className="iw__granted">
          <div className="iw__blink iw__ok">ACCESS GRANTED</div>
          <p>welcome downstairs. <b>BASEMENT.exe</b> is on your desktop now.</p>
          <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('ic:open', { detail: 'Basement' }))}>open BASEMENT.exe</button>
        </div>
      ) : (
        <form className="iw__form" onSubmit={submit}>
          <label>ENTER THE KEY</label>
          <input value={key} onChange={e => setKey(e.target.value)} autoComplete="off" spellCheck={false} placeholder="•••••" />
          <button type="submit">ENTER</button>
          {state === 'denied' && <div className="iw__blink iw__bad">ACCESS DENIED</div>}
          {tries >= 3 && <div className="iw__hint">hint: count the eights that open the contract address. that many eights. nothing else.</div>}
          {tries >= 6 && <div className="iw__hint">hint 2: it is five characters long and it is on the BUY window.</div>}
        </form>
      )}
      <div className="iw__counter">you are visitor <span>{String(88888 + tries).padStart(7, '0')}</span></div>
      <div className="iw__fine">this page is best viewed in 800×600 with the lights off. no cookies. no server. the key never leaves your browser.</div>
      <Ring goto={goto} />
    </Page>
  );
}

function Construction({ goto }) {
  return (
    <Page>
      <div className="iw__uc"><span>🚧 UNDER CONSTRUCTION 🚧</span></div>
      <h1>this page is under construction</h1>
      <p className="iw__sub">since 1999. it is never going to be finished. that is the point.</p>
      <div className="iw__gifrow"><span>▮▮▮▮▮▯▯▯▯▯ 47%</span><span className="iw__blink">NEW!</span><span>[ sign my guestbook ]</span><span>[ email the webmaster ]</span></div>
      <p>things that will be here soon: a links page. a midi that autoplays. a photo of the webmaster&apos;s cat. a counter that lies. a frames version.</p>
      <p className="iw__fine">last updated: never · best viewed in Netscape Navigator 4.7 · this site is Y2K compliant</p>
      <div className="iw__counter">you are visitor <span>0000001</span></div>
      <Ring goto={goto} />
    </Page>
  );
}

function Webring({ goto }) {
  return (
    <Page>
      <h1>the internet webring</h1>
      <p className="iw__sub">sites that live inside this computer. no DNS. no hosting. no way out.</p>
      <table className="iw__table">
        <tbody>
          <tr><td>▸</td><td><a onClick={() => goto('internetcoin.vip')}>internetcoin.vip</a></td><td>the homepage. the coin. the mission.</td></tr>
          <tr><td>▸</td><td><a onClick={() => goto('underconstruction.internetcoin.vip')}>underconstruction.internetcoin.vip</a></td><td>under construction since 1999.</td></tr>
          <tr><td>▸</td><td><a onClick={() => goto('basement.internetcoin.vip')}>basement.internetcoin.vip</a></td><td>members only. you need a key.</td></tr>
          <tr><td>▸</td><td><span className="iw__dead">level2.internetcoin.vip</span></td><td>does not exist. yet.</td></tr>
        </tbody>
      </table>
      <p>type any real site in the address bar and the Time Machine serves it from the year you pick. these four are the only ones that are actually <i>here</i>.</p>
      <Ring goto={goto} />
    </Page>
  );
}

export function InternalPage({ page, goto }) {
  if (page === 'basement') return <Door goto={goto} />;
  if (page === 'construction') return <Construction goto={goto} />;
  return <Webring goto={goto} />;
}

const Page = styled.div`
  min-height: 100%;
  padding: 26px 30px 40px;
  background: #000 radial-gradient(circle at 20% 10%, rgba(204,255,0,.12), transparent 40%);
  background-image: radial-gradient(#fff 0.6px, transparent 0.7px), radial-gradient(#ccff00 0.5px, transparent 0.6px);
  background-size: 90px 90px, 140px 140px;
  color: #d9ffa3;
  font-family: Verdana, Tahoma, sans-serif;
  font-size: 12px;
  text-align: center;
  h1 { font-family: Impact, 'Arial Black', sans-serif; font-size: 44px; letter-spacing: 2px; color: #ccff00; text-shadow: 3px 3px 0 #3a5000, 0 0 24px rgba(204,255,0,.6); margin: 14px 0 6px; }
  p { line-height: 1.6; max-width: 620px; margin: 8px auto; }
  .iw__sub { color: #fff; font-style: italic; }
  .iw__uc { display: inline-block; padding: 6px; background: repeating-linear-gradient(45deg, #ccff00 0 12px, #000 12px 24px);
    span { display: block; padding: 3px 14px; background: #000; color: #ccff00; font-weight: 700; font-family: Impact, 'Arial Black', sans-serif; letter-spacing: 2px; } }
  .iw__marquee { overflow: hidden; white-space: nowrap; border-top: 1px solid #5d7a00; border-bottom: 1px solid #5d7a00; margin: 12px auto; max-width: 620px;
    span { display: inline-block; padding-left: 100%; animation: iw-marquee 16s linear infinite; color: #ccff00; } }
  @keyframes iw-marquee { from { transform: translateX(0); } to { transform: translateX(-100%); } }
  .iw__form { display: flex; flex-direction: column; align-items: center; gap: 8px; margin: 18px auto 10px;
    label { color: #8fb800; letter-spacing: 3px; }
    input { width: 180px; height: 30px; text-align: center; font: bold 18px 'Lucida Console', monospace; letter-spacing: 6px; background: #0f120a; color: #ccff00; border: 2px inset #7a9a00; outline: none; }
    button { height: 28px; padding: 0 22px; font: bold 12px Verdana, sans-serif; background: #ccff00; color: #000; border: 2px outset #eaff80; cursor: pointer; letter-spacing: 2px; &:active { border-style: inset; } } }
  .iw__granted { margin: 18px auto 10px; button { height: 28px; padding: 0 22px; font: bold 12px Verdana, sans-serif; background: #ccff00; color: #000; border: 2px outset #eaff80; cursor: pointer; letter-spacing: 1px; } }
  .iw__blink { animation: iw-blink 1s steps(2, start) infinite; font-family: Impact, 'Arial Black', sans-serif; font-size: 22px; letter-spacing: 3px; }
  @keyframes iw-blink { to { visibility: hidden; } }
  .iw__bad { color: #ff3b3b; }
  .iw__ok { color: #ccff00; }
  .iw__hint { color: #8fb800; font-style: italic; max-width: 420px; }
  .iw__counter { margin-top: 18px; color: #8fb800; span { display: inline-block; background: #000; color: #ccff00; border: 1px solid #5d7a00; padding: 1px 6px; font-family: 'Lucida Console', monospace; letter-spacing: 3px; } }
  .iw__fine { color: #5d7a00; font-size: 10px; margin-top: 10px; }
  .iw__gifrow { display: flex; justify-content: center; gap: 14px; flex-wrap: wrap; margin: 10px 0; color: #ccff00; font-family: 'Lucida Console', monospace; font-size: 11px; }
  .iw__table { margin: 14px auto; text-align: left; border-collapse: collapse; td { padding: 4px 8px; vertical-align: top; } .iw__dead { color: #5d7a00; text-decoration: line-through; } }
  a { color: #ccff00; text-decoration: underline; cursor: pointer; &:hover { color: #fff; } }
  .iw__ring { margin-top: 28px; padding-top: 10px; border-top: 1px dashed #5d7a00; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; font-size: 11px; span { color: #8fb800; } }
`;
